import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthStore } from '@app/stores/auth.store';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from 'src/app/components/common/modal/modal.component';

@Component({
  selector: 'app-experienced-congrat-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe, ModalComponent],
  templateUrl: './experienced-congrat-dialog.component.html',
  styleUrl: './experienced-congrat-dialog.component.scss',
})
export class ExperiencedCongratDialogComponent {
  protected store = inject(AuthStore);

  constructor(public activeModal: NgbActiveModal) {}

  protected handlePrimaryAction() {
    this.activeModal.close();
  }
}
